module.exports = __webpack_public_path__ + "img/csm__MG_9021_1e5195c2fc.d652fec5.jpg";